import { render, staticRenderFns } from "./CafeteriaViewGlobal.vue?vue&type=template&id=07ba23aa"
import script from "./CafeteriaViewGlobal.vue?vue&type=script&lang=js"
export * from "./CafeteriaViewGlobal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports